export const BACKEND_API_BASE_URL = "https://demo.atservicecrm.com/api/";
export const CDN_URL = "https://demo.atservicecrm.com/";
